import { render, staticRenderFns } from "./FeatureData.vue?vue&type=template&id=4007803d&scoped=true&"
import script from "./FeatureData.vue?vue&type=script&lang=js&"
export * from "./FeatureData.vue?vue&type=script&lang=js&"
import style0 from "./FeatureData.vue?vue&type=style&index=0&id=4007803d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4007803d",
  null
  
)

export default component.exports